import NutritionalSummary from './NutritionalSummary';

export default NutritionalSummary;
